import { createSelector } from 'reselect';

import { QUESTION_MODELS_STATUS } from 'modules/questionModels/constants';
import { getState as getParent, getRoot, getByIds } from 'modules/questionModels/selectors';
import { getSelfServiceStatsDashboardFetchParams } from 'modules/statistics/selectors';

const getState = createSelector(getParent, state => state.ui.select);

export const hasMore = createSelector(getState, config => config.hasMore);

export const getPage = createSelector(getState, config => config.page);

const getIds = createSelector(getState, config => config.ids);

export const isLoading = createSelector(getState, config => config.loading);

export const getError = createSelector(getState, config => config.error);

export const getList = createSelector(getRoot, getIds, getByIds);

export const getParams = createSelector(
  getPage,
  getSelfServiceStatsDashboardFetchParams,
  (page, filters) => ({
    status: QUESTION_MODELS_STATUS.OPEN,
    projection: 'details',
    page: page.number ?? 0,
    size: page.size ?? 20,
    sort: ['dealerId,desc', 'groupId,desc', 'name,asc'],
    ...filters,
  })
);
